<template>
  <div>
    <loading :fullscrean="true" text="Carregando as informações"/>
  </div>
</template>

<script>
  import Loading from '../../../components/Loading'

  export default {
    name: 'Home',
    components: { Loading },
    created() {
      window.location.replace("https://www.lecard.delivery");
    },
  }
</script>

<style scoped>
</style>